import React from 'react';
import { CardMedia, globalizationPath, PageSection, useGlobal } from '@rcg/ui-react';
import { Box, Container } from '@material-ui/core';
import { Typography } from '@rcg/ui-react/lib/components';
import useStyles from './index.styles';
import {
  AMEND_ORIGIN,
  FLIGHTS_ROUTE,
  SESSION_STORAGE_CHANGE_FLIGHTS,
  SESSION_STORAGE_BOOKING_PROFILE,
  SESSION_STORAGE_FLIGHT_TYPE_CODE,
} from '../../commons/constants';

import { trackAddFlightsCTA } from '../../commons';
import { setSessionStorageItem } from '../../commons/utils';

const AddFlights = ({ currency }) => {
  const classes = useStyles();
  const {
    data: { lang, market },
    renderContent,
  } = useGlobal();
  const flightsPath = globalizationPath(market, lang, FLIGHTS_ROUTE);

  const { sectionTitle, cardTitle, ctaLabel, flightDescriptionAmendSectionTitle, sectionSubtitle } =
    {
      sectionTitle: renderContent('flightDetailsAmendSectionTitle', 'Flight Details'),
      flightDescriptionAmendSectionTitle: renderContent(
        'flightDescriptionAmendSectionTitle',
        `With Royal Caribbean International®'s Air2Sea program, you're guaranteed the lowest priced airfare on your choice of preferred airlines. Choose your flights, and we will take care of the rest.`,
      ),
      sectionLink: `${renderContent(
        'addFlightsBookWithAmendSection',
        'BOOK WITH',
      )} ROYAL CARIBBEAN`,
      cardTitle: renderContent(
        'besPriceFlightsBookingAmendCardTitle',
        'GET THE BEST PRICE ON FLIGHTS',
      ),
      ctaLabel: renderContent('addFlightsBookingAmendCardCtaButton', 'Search flights'),
      sectionSubtitle: renderContent('amendCardFlightSubtitle', 'Book with royal caribbean'),
    };

  const handleActionClick = () => {
    sessionStorage.setItem(AMEND_ORIGIN, 'true');
    setSessionStorageItem(SESSION_STORAGE_CHANGE_FLIGHTS, false);
    setSessionStorageItem(SESSION_STORAGE_BOOKING_PROFILE, null);
    setSessionStorageItem(SESSION_STORAGE_FLIGHT_TYPE_CODE, null);
    trackAddFlightsCTA(currency);
    window.location.assign(flightsPath);
  };

  return (
    <Box className={classes.rootAddFlights}>
      <PageSection
        className={classes.addFlights}
        title={sectionTitle}
        linkHref="/plan-a-cruise/transportation"
        linkTarget="_blank">
        <Container maxWidth={false} className={classes.hero}>
          <CardMedia
            className={classes.addFlightsMedia}
            filterClass={classes.filterMedia}
            title={cardTitle}
            description={flightDescriptionAmendSectionTitle}
            buttonLabel={ctaLabel}
            buttonAction={handleActionClick}
            mediaPortait="(max-width: 960px)"
            mediaLandscape="(max-width: 1280px)"
            defaultImg="https://assets.dm.rccl.com/is/image/RoyalCaribbeanCruises/royal/special-mkgt/transportation/air-to-sea-airplane-palm-trees-summer.jpg?$1440x600$">
            <Typography component="p" className={classes.firstText}>
              {sectionSubtitle}
            </Typography>
          </CardMedia>
          <div className={classes.gradientOverlay} />
        </Container>
      </PageSection>
    </Box>
  );
};

export default AddFlights;
